import React , { useEffect } from 'react';
import { Grid, Paper, TextField, Button, CssBaseline } from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import {API_URL} from "./config";
import logo from './assets/logo.svg';
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";


function Copyright(props) {
  return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="https://acilcocukdoktoru.com/">
          Acilcocukdoktoru.com
        </Link>{' '}
        {new Date().getFullYear()}
        {/* {'.'} */}
      </Typography>
  );
}

const theme = createTheme();

const ResetPassword = () => {
  const { reset_code } = useParams();
  const paperStyle = { padding: 30, height: '60vh', width: 360, margin: '0 auto' };
  const avatarStyle = { backgroundColor: '#1976D2' };
  const btnstyle = { margin: '8px 0' };


  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required('Şifre zorunludur')
      .min(8, 'Şifre en az 8 karakter uzunluğunda olmalıdır')
      .test(
        'has-uppercase',
        'En az bir büyük harf içermelidir',
        (value) => /[A-Z]/.test(value)
      )
      .test(
        'has-special-char',
        'En az bir özel karakter içermelidir',
        (value) => /[@#$%^&*()\-._+=<>?/]/.test(value)
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Şifreler eşleşmiyor')
      .required('Şifre doğrulama zorunludur'),
  });



  const handleSubmit = async (values) => {
    try {
      const response = await axios.post(
        `${API_URL}/auth/reset-password/${reset_code}`,
        null,
        {
          params: {
            new_password: values.password,
            confirm_new_password: values.confirmPassword,
            reset_code: reset_code,
          },
        }
      );

      console.log('Response:', response.data);

      if (response.data.message === "Şifre başarıyla sıfırlandı") {

        alert("Şifre başarıyla sıfırlandı");
        window.location.replace('/')
      } else {

        alert("Bir hata oluştu. Şifre sıfırlanamadı.");
      }
    } catch (error) {
      console.error('Bir hata oluştu:', error);

      if (error.response) {
        console.error('Sunucu tarafından gönderilen hata:', error.response.data);

        alert(`Sunucu hatası: ${error.response.data.detail}`);
      }
    }
  };





  return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Container component="main" maxWidth="xs" style={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',

        }}>

          <Box
              sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
          >
    <Grid align="center" >
      <CssBaseline />
      <Paper elevation={10} style={paperStyle}>
        <Grid align="center">
                <img width={'70%'} src={logo}  />
                <br/>
                <Typography component="h1" variant="h5" textAlign={'center'}>
                    Acilcocukdoktoru.com
                  <br/>
                </Typography>
          <h2>Şifreyi Sıfırla</h2>
        </Grid>
        <Formik
          initialValues={{ password: '', confirmPassword: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          <Form>
            <Field
              as={TextField}
              label="Yeni Şifre"
              name="password"
              type="password"
              placeholder="Yeni Şifre"
              fullWidth
              required
              helperText={<ErrorMessage name="password" />}
            />
            <Field
              as={TextField}
              label="Tekrar Yeni Şifre"
              name="confirmPassword"
              type="password"
              placeholder="Tekrar Yeni Şifre"
              fullWidth
              required
              helperText={<ErrorMessage name="confirmPassword" />}
            />
            <Button
              type="submit"
              color="primary"
              variant="contained"
              style={btnstyle}
              fullWidth
            >
              Submit
            </Button>
          </Form>
        </Formik>
      </Paper>
    </Grid>
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />

        </Container>


      </ThemeProvider>
  );
};

export default ResetPassword;
